import { Spacing, Heading } from '@big-red-group/storefront-common-ui'
import CopyLink from '@/components/widgets/blog/CopyLink'
import { Wrapper, Subtitle } from '@/components/widgets/blog/BlogHeader.styles'

type BlogHeaderProps = {
  title: string
  subtitle?: string
}

const BlogHeader: React.FC<BlogHeaderProps> = ({ title, subtitle }) => {
  return (
    <>
      <Wrapper>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
        <Heading size="XXL" spacing={false} as="h1">
          {title}
        </Heading>
        <Spacing size="M" />
        {/* TODO  Confirm functionality of link icon*/}
        <CopyLink />
        <Spacing size="XXXL" />
      </Wrapper>
    </>
  )
}

export default BlogHeader
